/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // POWERPAY discount price updater
  function updatePowerPayPrices() {
    const productSection = document.querySelector('[data-section-type="product"]');
    if (!productSection) return;

    // Get the selected variant data from the product JSON
    const productJson = productSection.querySelector('[data-product-json]');
    if (!productJson) return;

    try {
      const product = JSON.parse(productJson.textContent);
      
      // Get the selected variant ID from the form
      const variantInput = productSection.querySelector('[name="id"]');
      if (!variantInput) return;
      
      const selectedVariantId = parseInt(variantInput.value);
      const selectedVariant = product.variants.find(v => v.id === selectedVariantId);
      
      if (!selectedVariant) return;

      const variantPrice = selectedVariant.price;
      
      // Find all price wrappers
      const priceWrappers = productSection.querySelectorAll('[data-price-wrapper]');
      
      priceWrappers.forEach(wrapper => {
        const powerpayContainer = wrapper.querySelector('.product__powerpay-discount');
        const regularPriceEl = wrapper.querySelector('[data-product-price]');
        const comparePriceEl = wrapper.querySelector('[data-compare-price]');
        
        // Get configurable values from data attributes
        const powerpayDiscount = parseInt(wrapper.getAttribute('data-powerpay-discount')) || 8000;
        const minPrice = parseInt(wrapper.getAttribute('data-powerpay-min-price')) || 39900;
        
        // If POWERPAY container exists, this block has the feature enabled
        if (powerpayContainer) {
          if (variantPrice >= minPrice) {
            // Show POWERPAY prices, hide regular price
            powerpayContainer.style.display = 'block';
            if (regularPriceEl) regularPriceEl.style.display = 'none';
            if (comparePriceEl) comparePriceEl.style.display = 'none';
            
            const normalPriceEl = powerpayContainer.querySelector('[data-product-price-powerpay-normal]');
            const discountPriceEl = powerpayContainer.querySelector('[data-product-price-powerpay-discount]');
            const comparePricePowerpayEl = powerpayContainer.querySelector('[data-compare-price-powerpay]');
            
            if (normalPriceEl && discountPriceEl && window.Shopify && window.Shopify.formatMoney) {
              const powerpayPrice = variantPrice - powerpayDiscount;
              normalPriceEl.textContent = window.Shopify.formatMoney(variantPrice, theme.moneyFormat || '{{amount}}');
              discountPriceEl.textContent = window.Shopify.formatMoney(powerpayPrice, theme.moneyFormat || '{{amount}}');
              
              // Update compare at price for POWERPAY section
              if (comparePricePowerpayEl) {
                if (selectedVariant.compare_at_price > variantPrice) {
                  comparePricePowerpayEl.style.display = '';
                  comparePricePowerpayEl.textContent = window.Shopify.formatMoney(selectedVariant.compare_at_price, theme.moneyFormat || '{{amount}}');
                } else {
                  comparePricePowerpayEl.style.display = 'none';
                }
              }
            }
          } else {
            // Hide POWERPAY prices, show regular price
            powerpayContainer.style.display = 'none';
            if (regularPriceEl) regularPriceEl.style.display = '';
            if (comparePriceEl && selectedVariant.compare_at_price > variantPrice) {
              comparePriceEl.style.display = '';
            }
          }
        }
      });
    } catch (e) {
      console.error('Error updating POWERPAY prices:', e);
    }
  }

  // Update POWERPAY prices when the page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updatePowerPayPrices);
  } else {
    updatePowerPayPrices();
  }

  // Update POWERPAY prices when variant changes
  // Listen for variant input changes
  document.addEventListener('change', function(e) {
    if (e.target && e.target.name === 'id' && e.target.form && e.target.form.querySelector('[data-product-form]')) {
      setTimeout(updatePowerPayPrices, 100);
    }
  });

  // Also listen for clicks on variant options (swatches, buttons, etc.)
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-option-value]') || e.target.closest('[data-popout-option]')) {
      setTimeout(updatePowerPayPrices, 100);
    }
  });

  // ============================================
  // Product Card Swatches - Detectar si necesita full width
  // ============================================
  function checkSwatchesWidth() {
    document.querySelectorAll('[data-swatches-images]').forEach(function(imagesContainer) {
      const productCard = imagesContainer.closest('.product-item');
      if (!productCard) return;

      const cardWidth = productCard.offsetWidth;
      const imagesCount = imagesContainer.querySelectorAll('.product-swatch-image').length;
      const imageWidth = 40; // width de cada imagen
      const gap = 6; // gap entre imágenes
      const padding = 8; // padding del contenedor
      const contentWidth = (imagesCount * imageWidth) + ((imagesCount - 1) * gap) + padding;
      
      // Si el contenido ocupa menos del 95% del ancho del card
      if (contentWidth < cardWidth * 0.95) {
        imagesContainer.classList.add('not-full');
      } else {
        imagesContainer.classList.remove('not-full');
      }
    });
  }

  // ============================================
  // Product Card Swatches - Precarga de imágenes
  // ============================================
  const preloadedImages = new Set();

  function preloadImage(url) {
    if (!url || preloadedImages.has(url)) return;
    preloadedImages.add(url);
    const img = new Image();
    img.src = url;
  }

  function preloadSwatchImages(swatch) {
    const primary = swatch.dataset.swatchPrimary;
    const secondary = swatch.dataset.swatchSecondary;
    if (primary) preloadImage(primary);
    if (secondary) preloadImage(secondary);
  }

  // ============================================
  // Product Card Swatches - Cambiar imágenes al hacer clic
  // ============================================
  function changeProductImages(productCard, primaryUrl, secondaryUrl, swatchUrl) {
    if (!productCard) return;

    const imageContainer = productCard.querySelector('[data-product-image]');
    if (!imageContainer) return;

    // Obtener contenedores de imagen principal y secundaria
    const primaryContainer = imageContainer.querySelector('[data-product-image-default]');
    const secondaryContainer = imageContainer.querySelector('.product-item__bg__under');

    // Cambiar imagen principal
    if (primaryContainer && primaryUrl) {
      const primaryImg = primaryContainer.querySelector('img');
      if (primaryImg) {
        // Guardar imagen original si no existe
        if (!primaryImg.dataset.originalSrc) {
          primaryImg.dataset.originalSrc = primaryImg.src;
          primaryImg.dataset.originalSrcset = primaryImg.srcset || '';
        }
        primaryImg.src = primaryUrl;
        primaryImg.srcset = '';
      }
    }

    // Cambiar imagen secundaria (hover)
    if (secondaryContainer && secondaryUrl) {
      const secondaryImg = secondaryContainer.querySelector('img');
      if (secondaryImg) {
        // Guardar imagen original si no existe
        if (!secondaryImg.dataset.originalSrc) {
          secondaryImg.dataset.originalSrc = secondaryImg.src;
          secondaryImg.dataset.originalSrcset = secondaryImg.srcset || '';
        }
        secondaryImg.src = secondaryUrl;
        secondaryImg.srcset = '';
      }
    }

    // Actualizar enlaces del producto si hay URL del swatch
    if (swatchUrl) {
      const productLinks = productCard.querySelectorAll('[data-product-link]');
      productLinks.forEach(function(link) {
        // Guardar URL original si no existe
        if (!link.dataset.originalHref) {
          link.dataset.originalHref = link.href;
        }
        link.href = swatchUrl;
        link.setAttribute('data-product-link', swatchUrl);
      });
    }
  }

  function updateActiveSwatches(productCard, clickedSwatch) {
    if (!productCard) return;

    const swatchIndex = clickedSwatch.dataset.swatchIndex;
    
    // Actualizar swatches de colores
    const colorSwatches = productCard.querySelectorAll('[data-swatches-colors] .product-swatch');
    colorSwatches.forEach(function(swatch) {
      swatch.classList.remove('is-current');
      if (swatch.dataset.swatchIndex === swatchIndex) {
        swatch.classList.add('is-current');
      }
    });

    // Actualizar swatches de imágenes
    const imageSwatches = productCard.querySelectorAll('[data-swatches-images] .product-swatch-image');
    imageSwatches.forEach(function(swatch) {
      swatch.classList.remove('is-current');
      if (swatch.dataset.swatchIndex === swatchIndex) {
        swatch.classList.add('is-current');
      }
    });
  }

  // ============================================
  // Product Card Swatches - Toggle en mobile + Cambio de imágenes
  // ============================================
  function initSwatchesToggle() {
    // Verificar anchos en carga y resize
    checkSwatchesWidth();
    window.addEventListener('resize', checkSwatchesWidth);

    // Precargar imágenes al hacer hover sobre el área de swatches
    document.addEventListener('mouseenter', function(e) {
      const wrapper = e.target.closest('[data-swatches-wrapper]');
      if (wrapper && !wrapper.dataset.preloaded) {
        wrapper.dataset.preloaded = 'true';
        wrapper.querySelectorAll('[data-swatch-primary]').forEach(preloadSwatchImages);
      }
    }, true);

    // Deshabilitar arrastre del carrusel sobre el área de swatches
    document.addEventListener('mousedown', function(e) {
      if (e.target.closest('[data-swatches-wrapper]')) {
        e.stopPropagation();
      }
    }, true);

    // Función para cerrar todos los swatches expandidos excepto uno opcional
    function closeAllSwatches(except) {
      document.querySelectorAll('[data-swatches-wrapper].is-expanded').forEach(function(el) {
        if (el !== except) {
          el.classList.remove('is-expanded');
        }
      });
    }

    document.addEventListener('click', function(e) {
      const productCard = e.target.closest('.product-item');
      const wrapper = e.target.closest('[data-swatches-wrapper]');
      
      // ============================================
      // Clic en swatch de color (span)
      // ============================================
      const colorSwatch = e.target.closest('[data-swatches-colors] .product-swatch[data-swatch-primary]');
      if (colorSwatch && productCard) {
        e.preventDefault();
        e.stopPropagation();
        
        const primaryUrl = colorSwatch.dataset.swatchPrimary;
        const secondaryUrl = colorSwatch.dataset.swatchSecondary;
        const swatchUrl = colorSwatch.dataset.swatchUrl;
        
        changeProductImages(productCard, primaryUrl, secondaryUrl, swatchUrl);
        updateActiveSwatches(productCard, colorSwatch);
        return;
      }

      // ============================================
      // Clic en swatch de imagen (a)
      // ============================================
      const imageSwatch = e.target.closest('[data-swatches-images] .product-swatch-image[data-swatch-primary]');
      if (imageSwatch && productCard) {
        e.preventDefault();
        e.stopPropagation();
        
        const primaryUrl = imageSwatch.dataset.swatchPrimary;
        const secondaryUrl = imageSwatch.dataset.swatchSecondary;
        const swatchUrl = imageSwatch.dataset.swatchUrl;
        
        changeProductImages(productCard, primaryUrl, secondaryUrl, swatchUrl);
        updateActiveSwatches(productCard, imageSwatch);
        
        // En mobile, cerrar el panel expandido después de seleccionar
        if (window.innerWidth < 750 && wrapper) {
          wrapper.classList.remove('is-expanded');
        }
        return;
      }

      // ============================================
      // Mobile: Toggle panel de swatches
      // ============================================
      if (window.innerWidth < 750) {
        const colorsView = e.target.closest('[data-swatches-colors]');
        const imagesView = e.target.closest('[data-swatches-images]');
        
        // Click en la vista de colores -> cerrar otros y expandir este
        if (colorsView && wrapper && !colorSwatch) {
          e.preventDefault();
          e.stopPropagation();
          closeAllSwatches(wrapper);
          wrapper.classList.add('is-expanded');
          return;
        }
        
        // Verificar si hay swatches expandidos
        const hasExpanded = document.querySelector('[data-swatches-wrapper].is-expanded');
        
        // Si hay swatches expandidos y el click es dentro de un product card pero fuera del swatch
        if (hasExpanded && productCard && !imagesView && !colorsView) {
          e.preventDefault();
          e.stopPropagation();
          closeAllSwatches();
          return;
        }
        
        // Click fuera de cualquier product card -> cerrar todos
        if (hasExpanded && !productCard) {
          closeAllSwatches();
        }
      }
    });
  }

  // Init on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatchesToggle);
  } else {
    initSwatchesToggle();
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
